import styled from 'styled-components';
import {StyledBoxWrapper} from "../../DigitizationDetails.styled";
import {tokens} from "../../../../../theme";

export const DigitizationMetadataWrapper = styled(StyledBoxWrapper)`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    width: 100%;
    padding: 16px;
    background: ${({theme}) => theme.palette.background.paper};
    font-size: ${tokens.fontSize.xl};
    border: solid 0.8px ${({theme}) => theme.palette.dividers.subtle};;
    border-radius: ${tokens.radius.lg};
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    gap: 16px;
    overflow: hidden;
    word-break: break-word;
`;